module.exports = __webpack_public_path__ + "img/126.45a6e3df.svg";